var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationExpiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3164,
    cy: 19,
    r: 19,
    fill: "#FCE5E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3164 19.5C31.3164 25.8512 26.1676 31 19.8164 31C13.4651 31 8.31641 25.8512 8.31641 19.5C8.31641 13.1487 13.4651 8 19.8164 8C26.1676 8 31.3164 13.1487 31.3164 19.5Z",
    fill: "#ED4337"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6774 13.9354C20.2152 13.9354 20.6512 14.3403 20.6512 14.8397V19.2877L23.6119 22.037C23.9922 22.3902 23.9922 22.9626 23.6119 23.3157C23.2316 23.6689 22.6152 23.6689 22.2349 23.3157L18.9889 20.3016C18.8062 20.1321 18.7036 19.9021 18.7036 19.6623V14.8397C18.7036 14.3403 19.1396 13.9354 19.6774 13.9354Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationExpiry);
export default __webpack_public_path__ + "static/media/notification_expiry.306bd75bac11cc6aa5a8a4a3f2edc3cd.svg";
export { ForwardRef as ReactComponent };